import React from 'react';
import { Calendar, Clock, Flag, Award } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели с популярными событиями
 */
const PopularEventsSidebar = ({ 
  russianHolidays, 
  setFormData,
  loadPreset
}) => {
  // Функция создания таймера для конкретного праздника
  const createTimerForHoliday = (holiday) => {
    setFormData(prev => ({
      ...prev,
      timerName: `Обратный отсчёт до ${holiday.name}`,
      targetDate: holiday.date,
      timerType: 'countdown',
      timerMode: 'date',
      theme: holiday.id === 'victory-day' 
        ? 'victory-day' 
        : holiday.id === 'russia-day' || holiday.id === 'unity-day'
        ? 'russian-flag'
        : holiday.id === 'new-year' || holiday.id === 'christmas'
        ? 'festive'
        : prev.theme
    }));
  };

  // Сортировка праздников по дате (ближайшие сначала)
  const sortedHolidays = [...russianHolidays].sort((a, b) => {
    const now = new Date();
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    
    // Если дата прошла, считаем её как в следующем году
    const timeToA = dateA < now ? dateA.setFullYear(dateA.getFullYear() + 1) - now : dateA - now;
    const timeToB = dateB < now ? dateB.setFullYear(dateB.getFullYear() + 1) - now : dateB - now;
    
    return timeToA - timeToB;
  });

  // Выбираем только ближайшие 5 праздников
  const upcomingHolidays = sortedHolidays.slice(0, 5);
  
  // Вычисляем дни до праздника
  const getDaysUntil = (dateStr) => {
    const now = new Date();
    const targetDate = new Date(dateStr);
    
    // Если дата прошла, считаем до этой даты в следующем году
    if (targetDate < now) {
      targetDate.setFullYear(targetDate.getFullYear() + 1);
    }
    
    const diffTime = Math.abs(targetDate - now);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  };
  
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calendar className="w-5 h-5 mr-2 text-indigo-500" />
        Популярные события
      </h3>
      
      <div className="space-y-3">
        {upcomingHolidays.map((holiday) => (
          <div 
            key={holiday.id}
            className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="flex justify-between items-start">
              <div>
                <h4 className="text-sm font-medium text-gray-900 dark:text-white flex items-center gap-1.5">
                  {holiday.id === 'victory-day' && <Award className="w-4 h-4 text-orange-500" />}
                  {(holiday.id === 'russia-day' || holiday.id === 'unity-day') && <Flag className="w-4 h-4 text-blue-500" />}
                  {holiday.name}
                </h4>
                <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                  {new Date(holiday.date).toLocaleDateString('ru-RU', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                </p>
              </div>
              <div className="flex flex-col items-end">
                <span className="text-xs font-medium text-indigo-600 dark:text-indigo-400 flex items-center">
                  <Clock className="w-3 h-3 mr-1" />
                  {getDaysUntil(holiday.date)} дн.
                </span>
                <Button
                  size="xs"
                  variant="link"
                  className="mt-1"
                  onClick={() => createTimerForHoliday(holiday)}
                >
                  Создать таймер
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-lg">
        <div className="flex items-start">
          <Flag className="w-5 h-5 text-red-600 dark:text-red-400 mr-2 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-red-700 dark:text-red-300">
              9 мая - День Победы
            </h4>
            <p className="text-xs text-red-600 dark:text-red-400 mt-1">
              Создайте таймер до следующего Дня Победы и выберите специальную тему оформления "День Победы" в цветах Георгиевской ленты.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularEventsSidebar;